// start:ng42.barrel
export * from './upload-progress.component';
// end:ng42.barrel

